"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
;
exports.withStorage = function (keys, storageType, prefix) {
    if (keys === void 0) { keys = []; }
    if (storageType === void 0) { storageType = 'local'; }
    if (prefix === void 0) { prefix = ''; }
    return function (WrappedComponent) {
        var _a;
        return (_a = (function (_super) {
                __extends(WithStorageHoc, _super);
                function WithStorageHoc(props) {
                    var _this = _super.call(this, props) || this;
                    _this.storage = storageType === 'local' ? localStorage : sessionStorage;
                    _this.setupStorage = function () { return keys.reduce(function (agg, key) {
                        agg[key] = _this.getOperationsForKey(key);
                        return agg;
                    }, {}); };
                    _this.getOperationsForKey = function (key) { return ([
                        _this.getItem(key),
                        function (val) { return _this.updateItem(key, val); },
                        function () { return _this.removeItem(key); },
                    ]); };
                    _this.prefixKey = function (key) { return !!prefix ? prefix + "." + key : key; };
                    _this.getItem = function (key) {
                        var prefixedKey = _this.prefixKey(key);
                        var currentJson = _this.storage.getItem(prefixedKey);
                        return currentJson ? JSON.parse(currentJson) : null;
                    };
                    _this.updateItem = function (key, val) {
                        var _a;
                        var prefixedKey = _this.prefixKey(key);
                        _this.storage.setItem(prefixedKey, JSON.stringify(val));
                        _this.setState((_a = {}, _a[key] = _this.getOperationsForKey(key), _a));
                    };
                    _this.removeItem = function (key) {
                        var _a;
                        var prefixedKey = _this.prefixKey(key);
                        _this.storage.removeItem(prefixedKey);
                        _this.setState((_a = {}, _a[key] = _this.getOperationsForKey(key), _a));
                    };
                    _this.state = _this.setupStorage();
                    return _this;
                }
                WithStorageHoc.prototype.render = function () {
                    return (react_1.default.createElement(WrappedComponent, __assign({}, this.props, this.state)));
                };
                return WithStorageHoc;
            }(react_2.Component)),
            _a.displayName = "withStorage(" + (WrappedComponent.displayName || 'Component') + ")",
            _a);
    };
};
